export var IAppType;
(function (IAppType) {
    IAppType["CONTACT"] = "contact-lists";
    IAppType["MAP"] = "maps";
    IAppType["GANTT"] = "gantt";
    IAppType["CALENDAR"] = "calendar";
    IAppType["KEEPASS"] = "keepass";
    IAppType["REMINDS"] = "reminder";
})(IAppType || (IAppType = {}));
